import { TFeatures } from 'components/DynamicFeatureProvider/types'
import { permissions as p } from 'store/user/permissions'

export const FEATURE_NAMES = {
  CareerProfiles: 'CareerProfiles',
  CareerSearch: 'CareerSearch',
  CollegeProfiles: 'CollegeProfiles',
  CollegeSearch: 'CollegeSearch',
  DirectMessages: 'DirectMessages',
  EventSearch: 'EventSearch',
  HighSchool: 'HighSchool',
  Inbox: 'Inbox',
  MyColleges: 'MyColleges',
  Notifications: 'Notifications',
  OutreachMessages: 'OutreachMessages',
  Parents: 'Parents',
  PostSearch: 'PostSearch',
  PreferencesSearch: 'PreferencesSearch',
  ProgramSearch: 'ProgramSearch',
  Surveys: 'Surveys',
  Visits: 'Visits',
} as const

const features = {
  [FEATURE_NAMES.CareerProfiles]: [p.VIEW_ANY_CAREER],
  [FEATURE_NAMES.CareerSearch]: [p.VIEW_ANY_CAREER, p.PERFORM_CAREER_SEARCH],
  [FEATURE_NAMES.CollegeProfiles]: [p.VIEW_ANY_COLLEGE_DETAIL],
  [FEATURE_NAMES.CollegeSearch]: [p.VIEW_ANY_COLLEGE_DETAIL, p.PERFORM_COLLEGE_SEARCH],
  [FEATURE_NAMES.DirectMessages]: [p.PARTICIPATE_IN_DISCUSSIONS],
  [FEATURE_NAMES.EventSearch]: [p.VIEW_ANY_COLLEGE_DETAIL, p.PERFORM_EVENT_SEARCH],
  [FEATURE_NAMES.HighSchool]: [p.STUDENT_IN_ASSOC_HIGH_SCHOOL],
  [FEATURE_NAMES.MyColleges]: [p.VIEW_ANY_COLLEGE_DETAIL, p.PERFORM_COLLEGE_SEARCH, p.VIEW_COLLEGE_PROSPECTS_FOR_SELF],
  [FEATURE_NAMES.Notifications]: [p.STUDENT_RECEIVES_NOTIFICATIONS],
  [FEATURE_NAMES.OutreachMessages]: [
    p.VIEW_ANY_COLLEGE_DETAIL,
    p.PERFORM_COLLEGE_SEARCH,
    p.STUDENT_RECEIVES_OUTREACH_MESSAGES,
  ],
  [FEATURE_NAMES.Parents]: [p.CAN_INVITE_PARENTS],
  [FEATURE_NAMES.PostSearch]: [p.VIEW_ANY_COLLEGE_DETAIL, p.PERFORM_POSTS_SEARCH],
  [FEATURE_NAMES.PreferencesSearch]: [p.VIEW_ANY_COLLEGE_DETAIL, p.PERFORM_PREFERENCE_SEARCH],
  [FEATURE_NAMES.ProgramSearch]: [p.VIEW_ANY_COLLEGE_DETAIL, p.PERFORM_PROGRAM_SEARCH],
  [FEATURE_NAMES.Surveys]: [p.STUDENT_IN_ASSOC_HIGH_SCHOOL, p.CAN_VIEW_STUDENT_AND_PARENT_SURVEYS],
  [FEATURE_NAMES.Visits]: [p.VIEW_VISITS_FOR_ASSOC_HIGH_SCHOOL],
} as TFeatures

export default features
